import { create } from 'zustand'
import { apiRequest } from '../utils/api'

const useRewardStore = create((set) => ({
  coins: 0,
  gems: 0,
  dailyStreak: 0,
  lastActivityDate: null,
  earnedBadges: [],
  totalBadgesEarned: 0,
  avatar: { character: 'explorer', skin: null, hat: null, handItem: null, background: null },
  nextRewardItem: null, // { item_name, price_coin, needed }

  fetchRewardSummary: async (USER_ID) => {
    try {
      const res = await apiRequest('/dashboard/summary', 'POST', { USER_ID })
      if (res.success === 'Y' && res.data) {
        const d = res.data
        set({
          coins: d.coins?.balance ?? 0,
          gems: d.gems?.balance ?? 0,
          dailyStreak: d.daily_streak?.current_streak ?? 0,
          lastActivityDate: d.daily_streak?.last_activity_date ?? null,
          totalBadgesEarned: d.badges_earned ?? 0,
          avatar: {
            character: d.avatar?.equipped_character || 'explorer',
            skin: d.avatar?.equipped_skin || null,
            hat: d.avatar?.equipped_hat || null,
            handItem: d.avatar?.equipped_hand_item || null,
            background: d.avatar?.equipped_background || null,
          },
        })
      }
    } catch (err) {
      console.error('fetchRewardSummary 에러:', err)
    }
  },

  fetchEarnedBadges: async (USER_ID) => {
    try {
      const res = await apiRequest('/badges/earned', 'POST', { USER_ID })
      if (res.success === 'Y' && res.data) {
        set({ earnedBadges: res.data.EARNED_BADGES || [] })
      }
    } catch (err) {
      console.error('fetchEarnedBadges 에러:', err)
    }
  },

  fetchAvatarProfile: async (USER_ID) => {
    try {
      const res = await apiRequest('/avatar/profile', 'POST', { USER_ID })
      if (res.success === 'Y' && res.data) {
        set({
          avatar: {
            character: res.data.CHARACTER || 'explorer',
            skin: res.data.SKIN || null,
            hat: res.data.HAT || null,
            handItem: res.data.HAND_ITEM || null,
            background: res.data.BACKGROUND || null,
          },
        })
      }
    } catch (err) {
      console.error('fetchAvatarProfile 에러:', err)
    }
  },

  fetchNextReward: async (USER_ID, currentCoins) => {
    try {
      const res = await apiRequest('/shop/items', 'POST', { USER_ID })
      if (res.success === 'Y' && res.data?.ITEMS) {
        const unpurchased = res.data.ITEMS
          .filter((item) => !item.is_purchased && item.price_coin > 0)
          .sort((a, b) => a.price_coin - b.price_coin)
        if (unpurchased.length > 0) {
          const next = unpurchased[0]
          set({
            nextRewardItem: {
              item_name: next.item_name,
              price_coin: next.price_coin,
              needed: Math.max(0, next.price_coin - currentCoins),
            },
          })
        }
      }
    } catch (err) {
      console.error('fetchNextReward 에러:', err)
    }
  },

  // 아바타 장착 상태 직접 갱신 (저장 후 호출)
  updateAvatar: (avatar) => set({ avatar }),

  // 코인/젬 잔액 직접 갱신 (구매 후 호출)
  updateBalance: ({ coins, gems }) =>
    set((s) => ({
      coins: coins !== undefined ? coins : s.coins,
      gems: gems !== undefined ? gems : s.gems,
    })),
}))

export default useRewardStore
